import styled, { keyframes } from "styled-components";

const pulseRing = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(22, 119, 255, .45); }
  70%  { box-shadow: 0 0 0 5px rgba(22, 119, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(22, 119, 255, 0); }
`;

export const StyledWrapper = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  height: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.75rem;
  overflow: hidden;

  .ant-modal {
    top: 8%;
  }

  .ant-modal-header {
    max-width: 95%;
    margin-bottom: 1.125rem;
  }

  .ant-modal-close {
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    animation: ${pulseRing} 1.6s ease-out infinite;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  align-items: center;
  text-align: center;
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.35;
`;

export const StyledSubtitle = styled.div<{ $error?: boolean }>`
  font-size: 0.84375rem;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ $error }) => ($error ? '#ff4d4f' : '#65676b')};
`;
